import React from 'react';
import { Button, Modal } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import modalContainer from 'packages/common/modalContainer';

type PreventExportModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const PreventExportModal = ({ isOpen, onClose }: PreventExportModalProps) => {
    const { translate } = useTranslate();

    if (!isOpen) {
        return null;
    }

    return (
        <Modal
            container={modalContainer}
            title={translate('design.sidebar.shots.modal.overset.title')}
            isOpen={isOpen}
            onClose={onClose}
            actionPrimary={
                <Button variant="primary" onClick={onClose}>
                    {translate('design.sidebar.shots.modal.overset.button')}
                </Button>
            }
        >
            {translate('design.sidebar.shots.modal.overset.content')}
        </Modal>
    );
};

export default React.memo(PreventExportModal);
